import React from 'react';

import { Svg } from '@lglp/components';

import styles from './SliderArrow.module.scss';

export enum ArrowOrientation {
  LEFT,
  RIGHT,
}

const SliderArrow: React.FC<SliderArrowProps> = (props) => {
  const { orientation = ArrowOrientation.RIGHT, className, ...rest } = props;

  let orientationClassName = styles.right;
  switch (orientation) {
    case ArrowOrientation.LEFT: {
      orientationClassName = styles.left;
      break;
    }
    case ArrowOrientation.RIGHT:
    default: {
      orientationClassName = styles.right;
      break;
    }
  }

  return (
    <Svg
      className={[styles.sliderArrow, orientationClassName, className]}
      width="29.5"
      height="53.281"
      viewBox="0 0 35 53.281"
      {...rest}
    >
      <path
        id="Rectangle_arrondi_1"
        data-name="Rectangle arrondi 1"
        className="cls-1"
        d="M1230.83,410.544l22.63,22.628a4,4,0,0,1,0,5.656l-22.63,22.628a4,4,0,0,1-5.66,0V410.544A4,4,0,0,1,1230.83,410.544Z"
        transform="translate(-1225.16 -409.375)"
      />
    </Svg>
  );
};

type SliderArrowProps = {
  orientation?: ArrowOrientation;
  className?: string;
};

export default SliderArrow;
